import mixpanel from 'mixpanel-browser';
import store from '../app/store';

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN || '';

mixpanel.init(MIXPANEL_TOKEN, {
  debug: true,
  track_pageview: true,
  persistence: "localStorage",
  autocapture: {
    pageview: "full-url",
    click: true, 
    input: true,
    scroll: true,
    submit: true,
    capture_text_content: false,
  },
  record_sessions_percent: 100,   
  record_heatmap_data: true,      
});

const trackEvent = (event:string, res?: object) => {
  const state = store.getState();
  const authState = state.auth;
  const userId = authState?.userKey || "";

  const addressPath = window.location.href;
  const eventProperties = {
    everestPartner: authState?.everestPartner ?? "Not Logged In",
    isMasterVendor: authState?.isMasterVendor ?? "Not Logged In",
    lanMandatory: authState?.lanMandatory ?? "Not Logged In",
    lanLength: authState?.lanLength ?? "Not Logged In",
    userEmail: authState?.userEmail ?? "Not Logged In",
    userKey: authState?.userKey ?? "Not Logged In",
    userRole: authState?.userRole ?? "Not Logged In",
    userToken: authState?.userToken ?? "Not Logged In",
    platform: 'k2',
    addressPath: addressPath,
    ...(typeof res === 'object' ? res : {})
  };
  
  if(userId) {
    mixpanel.identify(userId);
    if(Object.keys(authState).length > 0) {
      mixpanel.people.set({
        $name: authState?.currentUser?.phoneNumber ?? "",
        $email: authState?.userEmail ?? "",
        $phone: authState?.currentUser?.phoneNumber ?? "",
      });
    }
  }
  console.log("eventName ", event);
  console.log("eventProperties ", eventProperties);
  mixpanel.track(event, eventProperties);
};

const eventNames = {
  Login_Landing: "Login_Landing",
  Homescreen_Landing: "Homescreen_Landing",
  MoneyHOPOnline: "MoneyHOPOnline",
  MoneyHOPOnline_Beta: "MoneyHOPOnline_Beta",

  // Old
  Old_SendMoney_Proceed: "Old_SendMoney_Proceed",
  Old_Remitter_Select: "Old_Remitter_Select",
  Old_Recipient_Select: "Old_Recipient_Select",
  Old_Documents_Submit: "Old_Documents_Submit",
  Old_Review_LAN_Enter: "Old_Review_LAN_Enter",
  Old_Review_Submit: "Old_Review_Submit",
  Old_Review_Submit_Response: "Old_Review_Submit_Response",
  Old_Payment_Landing: "Old_Payment_Landing",
  Old_History_Pay_Click: "Old_History_Pay_Click",

  // New
  New_SendMoney_Proceed: "New_SendMoney_Proceed",
  New_Remitter_Select: "New_Remitter_Select",
  New_Recipient_Select: "New_Recipient_Select",
  New_Documents_Submit: "New_Documents_Submit",
  New_Review_LAN_Enter: "New_Review_LAN_Enter",
  New_Review_Submit: "New_Review_Submit",
  New_Payment_Landing: "New_Payment_Landing",
  New_History_Pay_Click: "New_History_Pay_Click",
};

const MixpanelConfig = {
  trackEvent,
  eventNames
}; 

export default MixpanelConfig;
